<template>
    <div class="row panel-body">
        <div v-for="(question, idx) in questions">
            <div class="row" style="padding: 0 15px; margin-bottom: -14px;">
                <div class="quiz-message-row alert-warning col-md-12" style=" height:auto;"
                     v-if="getCorrectionComment(question.qid) !== ''">CORRECTION COMMENT: &nbsp;
                    {{getCorrectionComment(question.qid)}}
                </div>
            </div>
            <quiz-translation-question
                    v-on:forceUpdate="forceUpdate()"
                    ref="questions"
                    :idx="idx"
                    :key="question.qid"
                    :qid="question.qid"
                    :type="question.type"
                    :suggestedAnswerOid="question.suggestedAnswerOid"
                    :level="question.level"
                    :XX_en="question.text.XX_en"
                    :itranslation="question.text[locale]"
                    :locale="locale"
                    :language-name="language"
                    :ioptions="question.options"
                    :pictureUrl="question.pictureUrl"
            ></quiz-translation-question>
        </div>

        <div class="row">
            <div class="col-xs-12 text-right">
                <submit-button :disabled="!allDataIsValid" title="Submit"></submit-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            questionsJson: String,
            language: String,
            locale: String,
            correctedQuestionIdsJson: String,
            correctedQuestionCommentsJson: String,
        },

        data: function() {
            return {
                questions: [],
                correctedQuestionIds: JSON.parse(this.correctedQuestionIdsJson),
                correctedQuestionComments: JSON.parse(this.correctedQuestionCommentsJson),
                updateTrigger: false,
            };
        },

        computed: {
            allDataIsValid: function() {
                if (this.updateTrigger) {
                    for (let index in this.$refs.questions) {
                        if (!this.$refs.questions[index].validate()) {
                            return false;
                        }
                    }
                    return true;
                }
            },
        },

        mounted() {
            let questions = JSON.parse(this.questionsJson);
            let tmpQuestionsArray = [];
            for (let idx in questions) {
                if (!('suggestedAnswerOid' in questions[idx])) {
                    questions[idx].suggestedAnswerOid = null;
                }
                tmpQuestionsArray.push(questions[idx]);
            }
            // don't push to this.questions inside of the loop, because it triggers re-rendering in every iteration.
            this.questions = tmpQuestionsArray;
            this.forceUpdate();
        },

        methods: {
            forceUpdate: function() {
                this.updateTrigger = false;
                this.$forceUpdate();
                this.updateTrigger = true;
            },

            getCorrectionComment: function(qid) {
                return this.correctedQuestionComments[qid] ?? '';
            },
        },
    };
</script>
